module.exports = __webpack_public_path__ + "static/img/demo-1.6a0e12b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/LightBox/demo-1.png
// module id = uFr+
// module chunks = 9